import { MessageDetail } from "../types";

export interface MessageDetailsState {
    currentIndex: number;
    messageIds: number[];
    currentMessage?: MessageDetail;
    loadingMessage: boolean;
    settingMessageRead: boolean;
    settingMessageUnread: boolean;
}

export const initialMessageDetailsState: MessageDetailsState = {
    currentIndex: 0,
    messageIds: [],
    loadingMessage: false,
    settingMessageRead: false,
    settingMessageUnread: false,
};
